import Button from "../buttons/Button";
import { FiDownload } from "react-icons/fi";
import React from "react";
import {useSelector} from "react-redux";
import {getButtonProcessingClass, isButtonProcessing} from "../../utils/common-utils";

const ButtonImport = (props) => {
  const { name, className, onClick, ...rest } = props;
  const buttonProcessingState = useSelector((state) => state.button_processing);
  const isProcessing = isButtonProcessing(buttonProcessingState, props)
  const processingClass = getButtonProcessingClass(isProcessing);
  const buttonClass = `${className || ""}`;
  return (
    <Button
      color="primary"
      type="submit"
      name={name}
      onClick={() => onClick()}
      className={`${buttonClass} ${processingClass}`}
      isProcessing={isProcessing}
      {...rest}
    >
      <FiDownload className="mr-[4px]" size={20} />
      インポート
    </Button>
  );
};

export default ButtonImport;
